import { Message } from 'element-ui'
// 针对后端返回的文本进行统一国际化  暂且用这种效率较高的方法
export default async state => {
  switch (state.msg) {
    case 'update success':
      Message.success($t('integration.update_successful'))
      return Promise.resolve()
    case 'ok':
      Message.success($t('integration.success'))
      return Promise.resolve()
    case 'query success':
      Message.success($t('integration.query_was_successful'))
      return Promise.resolve()
    case 'delete success':
      Message.success($t('integration.successfully_deleted'))
      return Promise.resolve()
    case 'add success':
      Message.success($t('integration.successfully_added'))
      return Promise.resolve()
    case 'update failure':
      Message.error($t('integration.update_failed'))
      return Promise.reject()
    case 'save success':
      Message.success($t('integration.saved_successfully'))
      return Promise.resolve()
    case 'save failure':
      Message.error($t('integration.save_failed'))
      return Promise.reject()
    case 'ok':
      Message.success($t('integration.operation_successful'))
      return Promise.resolve()
    case 'success':
      Message.success($t('integration.operation_successful'))
      return Promise.resolve()
    case 'upload success':
      Message.success($t('integration.upload_successful'))
      return Promise.resolve()
    case 'edited  failure':
      Message.error($t('integration.edit_failed'))
      return Promise.reject()
    case 'edited success':
      Message.success($t('integration.edit_succeeded'))
      return Promise.resolve()
    case 'resume success':
      Message.success($t('integration.operation_successful'))
      return Promise.resolve()
    case 'resume failure':
      Message.error($t('integration.operation_failed'))
      return Promise.reject()
    case 'delete error':
      Message.error($t('integration.delete_failed'))
      return Promise.reject()
    case 'Failed and Alarm trigger has bound Carrier':
      Message.warning($t('integration.alarm_trigger_bound_to_carrier'))
      return Promise.reject()
    case 'Failed and Terminal already exist':
      Message.warning($t('integration.display_name_already_exists'))
      return Promise.reject()
    case 'Import empty file':
      Message.warning($t('integration.import_an_empty_file'))
      return Promise.reject()
    case 'import failure':
      Message.error($t('integration.import_failed'))
      return Promise.reject()
    case 'import success':
      Message.success($t('integration.import_succeeded'))
      return Promise.resolve()
    case 'Please re-import the correct template file':
      Message.warning($t('integration.please_re_import_the_correct_template_file'))
      return Promise.reject()
    case 'Failed and Gateway already exist':
      Message.warning($t('integration.gateway_mac_already_exists'))
      return Promise.reject()
    case 'send success':
      Message.success($t('integration.sending_succeeded'))
      return Promise.resolve()
    case 'send failure':
      Message.error($t('integration.fail_in_send'))
      return Promise.reject()
    case 'clear success':
      Message.success($t('integration.purge_succeeded'))
      return Promise.resolve()
    case 'failed,mac is null or empty':
      Message.warning($t('integration.mac_is_empty'))
      return Promise.reject()
    case 'The parent menu does not exist, it may have been deleted':
      Message.warning($t('integration.the_parent_menu_does_not_exist_c__it_may_have_been_deleted'))
      return Promise.reject()
    case 'save successfully':
      Message.success($t('integration.saved_successfully'))
      return Promise.resolve()
    case 'select successfully':
      Message.success($t('integration.query_was_successful'))
      return Promise.resolve()
    case 'delete successfully':
      Message.success($t('integration.successfully_deleted'))
      return Promise.resolve()
    case 'delete failed':
      Message.error($t('integration.delete_failed'))
      return Promise.reject()
    case 'update successfully':
      Message.success($t('integration.update_successful'))
      return Promise.resolve()
    case 'update failed':
      Message.error($t('integration.update_failed'))
      return Promise.reject()
    case 'add successfully':
      Message.success($t('integration.successfully_added'))
      return Promise.resolve()
    case 'add failed':
      Message.error($t('integration.failed_to_add'))
      return Promise.reject()
    case 'query failure':
      Message.success($t('integration.query_failed'))
      return Promise.reject()
    case 'select successfully':
      Message.success($t('integration.query_was_successful'))
      return Promise.resolve()
    case 'batchSave success':
      Message.success($t('integration.successfully_saved_in_batch'))
      return Promise.resolve()
    case 'error':
      Message.error($t('integration.operation_failed'))
      return Promise.reject()
    case 'export success':
      Message.success($t('integration.export_succeeded'))
      return Promise.resolve()
    case 'sort success':
      Message.success($t('integration.sort_succeeded'))
      return Promise.resolve()
    case 'sort failure':
      Message.error($t('integration.sort_failed'))
      return Promise.reject()
    case 'add failure':
      Message.error($t('integration.failed_to_add'))
      return Promise.reject()

      // 如果以上情况都无法匹配 则匹配code返回统一提示
    default:
      if (state.code === 200 || state.code === 200) {
        Message.success($t('integration.operation_successful'))
        return Promise.resolve()
      } else {
        Message.error($t('integration.operation_failed'))
        return Promise.reject()
      }
  }
}
